import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

const NewArrivalTwo = ({ currentProductId, currentProductCategory }) => {
    const [similarProducts, setSimilarProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    function SampleNextArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button" onClick={onClick}
                className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-right" />
            </button>
        );
    }

    function SamplePrevArrow(props) {
        const { className, onClick } = props;
        return (
            <button
                type="button"
                onClick={onClick}
                className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
            >
                <i className="ph ph-caret-left" />
            </button>
        );
    }

    // Fetch similar products based on current product's category
    useEffect(() => {
        const fetchSimilarProducts = async () => {
            try {
                setLoading(true);
                let url = 'http://localhost:5000/api/products?limit=12';
                
                if (currentProductCategory) {
                    const categoryMap = {
                        'Indoor Plants': 'indoor',
                        'Outdoor Plants': 'outdoor',
                        'Flowering Plants': 'flowering',
                        'Fruit Plants': 'fruit',
                        'Succulents': 'succulents',
                        'Cacti': 'cacti',
                        'Air Purifying Plants': 'air',
                        'Herbs': 'herbs',
                        'Ferns': 'ferns'
                    };
                    
                    const categoryParam = categoryMap[currentProductCategory] || currentProductCategory.toLowerCase();
                    url = `http://localhost:5000/api/products?category=${categoryParam}&limit=12`;
                }
                
                const response = await fetch(url);
                
                if (!response.ok) {
                    throw new Error('Failed to fetch products');
                }
                
                const data = await response.json();
                
                if (data.success && data.data) {
                    let products = data.data;
                    if (currentProductId) {
                        products = products.filter(product => product._id !== currentProductId);
                    }
                    setSimilarProducts(products.slice(0, 12));
                } else {
                    setSimilarProducts([]);
                }
            } catch (err) {
                console.error('Error fetching similar products:', err);
                setError('Failed to load similar products');
            } finally {
                setLoading(false);
            }
        };

        fetchSimilarProducts();
    }, [currentProductId, currentProductCategory]);

    const formatReviewCount = (count) => {
        if (count >= 1000) {
            return `${(count / 1000).toFixed(1)}k`;
        }
        return count;
    };

    const settings = {
        dots: false,
        arrows: true,
        infinite: similarProducts.length > 6,
        speed: 1000,
        slidesToShow: Math.min(6, similarProducts.length),
        slidesToScroll: 1,
        initialSlide: 0,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1599,
                settings: {
                    slidesToShow: Math.min(6, similarProducts.length),
                },
            },
            {
                breakpoint: 1399,
                settings: {
                    slidesToShow: Math.min(4, similarProducts.length),
                },
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: Math.min(3, similarProducts.length),
                },
            },
            {
                breakpoint: 575,
                settings: {
                    slidesToShow: Math.min(2, similarProducts.length),
                },
            },
            {
                breakpoint: 424,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    if (loading) {
        return (
            <section className="new-arrival pb-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">You Might Also Like</h5>
                            <Link to="/shop" className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline">
                                All Products
                            </Link>
                        </div>
                    </div>
                    <div className="text-center py-5">
                        <div className="spinner-border text-main-600" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p className="mt-3">Loading similar products...</p>
                    </div>
                </div>
            </section>
        );
    }

    if (error) {
        return (
            <section className="new-arrival pb-80">
                <div className="container container-lg">
                    <div className="section-heading">
                        <div className="flex-between flex-wrap gap-8">
                            <h5 className="mb-0">You Might Also Like</h5>
                            <Link to="/shop" className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline">
                                All Products
                            </Link>
                        </div>
                    </div>
                    <div className="alert alert-danger text-center" role="alert">
                        {error}
                    </div>
                </div>
            </section>
        );
    }

    if (similarProducts.length === 0) {
        return null;
    }

    return (
        <section className="new-arrival pb-80">
            <div className="container container-lg">
                <div className="section-heading">
                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">You Might Also Like</h5>
                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                All Products
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="new-arrival__slider arrow-style-two">
                    <Slider {...settings}>
                        {similarProducts.map((product) => (
                            <div key={product._id}>
                                <div 
                                    className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2"
                                    style={{
                                        overflow: 'hidden',
                                        backgroundColor: '#fff',
                                        zIndex: 1
                                    }}
                                >
                                    {product.badge && (
                                        <span className={`product-card__badge ${product.badgeColor || 'bg-danger-600'} px-8 py-4 text-sm text-white`}
                                            style={{
                                                position: 'absolute',
                                                top: '10px',
                                                left: '10px',
                                                zIndex: 2
                                            }}
                                        >
                                            {product.badge}
                                        </span>
                                    )}
                                    {product.discountPercentage > 0 && !product.badge && (
                                        <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white"
                                            style={{
                                                position: 'absolute',
                                                top: '10px',
                                                left: '10px',
                                                zIndex: 2
                                            }}
                                        >
                                            Sale {product.discountPercentage}%
                                        </span>
                                    )}
                                    <Link
                                        to={`/product-details/${product._id}`}
                                        className="product-card__thumb flex-center"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            overflow: 'hidden',
                                            borderRadius: '12px',
                                            margin: '0 auto',
                                            width: '100%',
                                            height: '200px',
                                            position: 'relative',
                                            zIndex: 1
                                        }}
                                    >
                                        <img 
                                            src={product.image || 'assets/images/thumbs/product-img7.png'} 
                                            alt={product.name}
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease',
                                                display: 'block'
                                            }}
                                            onError={(e) => {
                                                e.target.src = 'assets/images/thumbs/product-img7.png';
                                            }}
                                        />
                                    </Link>
                                    <div className="product-card__content p-sm-2" style={{ position: 'relative', zIndex: 1, background: '#fff' }}>
                                        <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                            <Link to={`/product-details/${product._id}`} className="link text-line-2" style={{ textDecoration: 'none', color: 'inherit' }}>
                                                {product.name.length > 50 ? product.name.substring(0, 50) + '...' : product.name}
                                            </Link>
                                        </h6>
                                        <div className="flex-align gap-4">
                                            <span className="text-main-600 text-md d-flex">
                                                <i className="ph-fill ph-storefront" />
                                            </span>
                                            <span className="text-gray-500 text-xs">
                                                By {product.vendorName || 'Paudhawala Nursery'}
                                            </span>
                                        </div>
                                        <div className="product-card__content mt-12">
                                            <div className="product-card__price mb-8">
                                                <span className="text-heading text-md fw-semibold ">
                                                    ₹{product.price?.toFixed(2) || '0.00'} <span className="text-gray-500 fw-normal">/{product.unit || 'Plant'}</span>
                                                </span>
                                                {product.originalPrice && product.originalPrice > product.price && (
                                                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through ms-2">
                                                        ₹{product.originalPrice.toFixed(2)}
                                                    </span>
                                                )}
                                            </div>
                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-600">{product.rating || '4.7'}</span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-600">({formatReviewCount(product.reviewsCount || 0)})</span>
                                            </div>
                                            <Link
                                                to="/cart"
                                                className="product-card__cart btn bg-main-50 text-main-600 hover-bg-main-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    gap: '8px',
                                                    zIndex: 1,
                                                    position: 'relative'
                                                }}
                                            >
                                                Add To Cart <i className="ph ph-shopping-cart" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>

            {/* Fix for overlapping/z-index issues */}
            <style>{`
                .new-arrival__slider .slick-slide {
                    overflow: visible !important;
                }
                
                .new-arrival__slider .slick-list {
                    overflow: hidden !important;
                }
                
                .product-card {
                    overflow: hidden !important;
                    transition: all 0.3s ease !important;
                }
                
                .product-card:hover {
                    transform: translateY(-5px) !important;
                    box-shadow: 0 8px 25px rgba(0,0,0,0.1) !important;
                }
                
                .product-card:hover img {
                    transform: scale(1.05) !important;
                }
                
                .product-card__thumb {
                    overflow: hidden !important;
                    position: relative !important;
                    z-index: 1 !important;
                }
                
                .product-card__badge {
                    z-index: 10 !important;
                    position: absolute !important;
                }
                
                .product-card__content {
                    position: relative !important;
                    z-index: 2 !important;
                    background: white !important;
                }
                
                /* Ensure slider arrows are above content */
                .slick-arrow {
                    z-index: 100 !important;
                }
                
                .slick-prev {
                    left: -10px !important;
                    z-index: 100 !important;
                }
                
                .slick-next {
                    right: -10px !important;
                    z-index: 100 !important;
                }
                
                @media (max-width: 768px) {
                    .slick-prev {
                        left: -5px !important;
                    }
                    .slick-next {
                        right: -5px !important;
                    }
                }
            `}</style>
        </section>
    )
}

export default NewArrivalTwo;